<template>
  <!--个人下载任务记录-->
  <div id="myOneDnloadTaskList">
    <div>
      <div class="allDl m_t_20">
        <dl class="allDl_width20 allDl_span60">
          <dd>
            <span>订阅名称:</span>
            <div>
              <input v-model="serchData.Name" type="text" class="allInput"/>
            </div>
          </dd>
          <dd>
            <span>宽表名称:</span>
            <div>
              <allSelect v-model="serchData.TableId" :chooseData="myWideTableNameList" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
              </allSelect>
            </div>
          </dd>
          <dd>
            <span>状态:</span>
            <div>
              <allSelect v-model="serchData.Status" :chooseData="$commonJs.dnloadTaskTypeList" :needReturn="'id'" :matchValue="'name'" :showValue="'{{name}}'" :width="'100%'" :placeholder="'全部'" :borderLine="'#E5E5E5'">
              </allSelect>
            </div>
          </dd>
          <dt style="width: auto;">
            <button @click="allSerch()" class="suerButton"><i class="icon iconfont iconsousuo" style="font-size: 14px"></i><span class="m_l_5">搜索</span></button>
          </dt>
        </dl>
      </div>
      <div style="max-height: calc(100vh - 270px);overflow: auto">
        <table class="allTable" cellspacing="0">
          <thead>
          <tr>
            <th>ID</th>
            <th>下载文件名称</th>
            <th>宽表名称</th>
            <th>状态</th>
            <th>任务创建时间</th>
            <th>准备完成时间</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myAllList">
            <td>{{item.id}}</td>
            <td style="max-width: 160px" class="NoWrap" :title="item.fileName">{{item.fileName}}</td>
            <td>{{ item.tableName }}</td>
            <td :style="{'color': returnType(item.status, 2),'textAlign':'left'}">●&nbsp;{{returnType(item.status, 1)}}</td>
            <td>{{item.createTime}}</td>
            <td>{{item.finishTime}}</td>
            <td class="colorYellowF36A20" width="80">
              <div class="d_flex" style="justify-content: left">
                <span @click="allVideo(item)" class="c_p m_r_5">查看参数</span>
                <button @click="confirmExport(item)" v-if="item.status === 'Success'" class="c_p m_r_5 donBtn" :disabled="isBtn">下载</button>
                <span @click="allCancel(item)" v-if="item.status === 'WaitHandle'" class="c_p">取消</span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <page :totalCount="totalCount" v-if="totalPage !== 0" v-on:on-getList="getAllList($event)" :totalPage="totalPage" :page="page" :numPage="1"></page>
    </div>
    <model v-if="showModel" :title="'下载'" :minWidth="'60%'" :onButton="0" v-on:on-cancel="showModel = false">
      <div class="pd_10_20">
        <div class="dnlUl">
          <ul>
            <li>
              <span style="vertical-align: top">已选参数：</span>
              <div>
                <div class="dnlUl_par">
                  <p :key="index" v-for="(item, index) in subscriptionData.parameterJsonList">{{ item }}</p>
                </div>
              </div>
            </li>
            <!--<li>-->
            <!--  <span style="vertical-align: top;margin-top: 5px">邮箱地址：</span>-->
            <!--  <div>-->
            <!--    &lt;!&ndash;<section class="dnlUl_emlS">&ndash;&gt;-->
            <!--    &lt;!&ndash;  <input type="text" placeholder="请输入..."/>&ndash;&gt;-->
            <!--    &lt;!&ndash;  <div>&ndash;&gt;-->
            <!--    &lt;!&ndash;    <p>未找到任何结果</p>&ndash;&gt;-->
            <!--    &lt;!&ndash;    <p class="NoWrap">1234@qq.com</p>&ndash;&gt;-->
            <!--    &lt;!&ndash;    <p class="NoWrap">1234@qq.com</p>&ndash;&gt;-->
            <!--    &lt;!&ndash;  </div>&ndash;&gt;-->
            <!--    &lt;!&ndash;</section>&ndash;&gt;-->
            <!--    <div class="dnlUl_eml">-->
            <!--      <div :key="index" v-for="(item, index) in subscriptionData.subscribeEmails">-->
            <!--        <span class="m_r_10">{{ item }}</span>-->
            <!--        &lt;!&ndash;<i class="icon iconfont iconguanbi colorYellowF36A20"></i>&ndash;&gt;-->
            <!--      </div>-->
            <!--    </div>-->
            <!--  </div>-->
            <!--</li>-->
            <!--<li>-->
            <!--  <span>邮箱标题:</span>-->
            <!--  <div>-->
            <!--    <input v-model="subscriptionData.subscribeTitle" type="text"  class="allInput" style="width: calc(100% - 12px)" disabled/>-->
            <!--  </div>-->
            <!--</li>-->
            <!--<li>-->
            <!--  <span>正文：</span>-->
            <!--  <div>-->
            <!--    <textarea v-model="subscriptionData.subscribeBody" rows="5" class="allTextarea" style="width: calc(100% - 12px)" disabled></textarea>-->
            <!--  </div>-->
            <!--</li>-->
            <li>
              <span>文件类型：</span>
              <div>
                <span>{{ subscriptionData.fileType }}</span>
              </div>
            </li>
            <!--<li>-->
            <!--  <span>订阅周期：</span>-->
            <!--  <div>-->
            <!--    <span>{{ returnWeek(subscriptionData.uploadFrequency) }}</span>-->
            <!--  </div>-->
            <!--</li>-->
            <!--<li>-->
            <!--  <span>发送时间：</span>-->
            <!--  <div>-->
            <!--    <span>{{ subscriptionData.sendTime }}</span>-->
            <!--  </div>-->
            <!--</li>-->
          </ul>
        </div>
      </div>
    </model>
    <model v-if="showModel4" :title="'正在下载'" :minWidth="'60%'" :showClose="1" :onButton="0" v-on:on-cancel="showModel3 = false">
      <div class="pd_10_20">
        <div class="filrProgNum" style="margin: auto">
          <p class="d_flex">
            <span>{{ upName }}</span>
            <span class="colorGray9D9D9D">{{ uploadMdoel }}%</span>
          </p>
          <div class="m_t_5 m_b_5">
            <div :style="{'width': uploadMdoel + '%'}"></div>
          </div>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
export default {
  name: 'myOneDnloadTaskList',
  data () {
    return {
      isBtn: false,
      showModel4: false,
      uploadMdoel: 0,
      upName: '',
      showModel: false,
      totalPage: 0,
      totalCount: 0,
      page: 1,
      serchData: {
        Name: '',
        TableId: 0,
        IsPersonal: true,
        Status: 0,
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      postData: {
        Name: '',
        TableId: 0,
        IsPersonal: true,
        Status: 0,
        PageIndex: 1,
        PageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      myAllList: [],
      myWideTableNameList: [
        {
          id: 0,
          name: '全部'
        }
      ],
      subscriptionData: {
        id: 0,
        subscribeName: '',
        subscribeEmails: [], // 邮箱
        subscribeTitle: '', // 标题
        subscribeBody: '', // 正文
        parameterJson: '', // 已选参数
        parameterJsonList: [],
        tableId: this.formChildTableId,
        fileType: 1, // 文件类型 1 = excel, 2 = csv
        uploadFrequency: 'EveryDay', // EveryDay, EveryWeek, EveryMonth
        sendTime: ''
      },
      allWeek: [
        {
          id: 1,
          name: '周一'
        },
        {
          id: 2,
          name: '周二'
        },
        {
          id: 3,
          name: '周三'
        },
        {
          id: 4,
          name: '周四'
        },
        {
          id: 5,
          name: '周五'
        },
        {
          id: 6,
          name: '周六'
        },
        {
          id: 7,
          name: '周日'
        }
      ],
      logId: 0
    }
  },
  created () {
    this.$commonJs.addLog('查看', '数据下载', '个人下载任务记录', '')
    this.getWideTableNameList()
    this.getAllList(1)
  },
  methods: {
    // 获取宽表名称
    getWideTableNameList () {
      this.$axiox.get('/api/Download/GetDownloadTableList').then(msg => {
        let list = msg.data || []
        for (let i = 0; i < list.length; i++) {
          if (list[i]) {
            let data = {
              id: list[i].key,
              name: list[i].value
            }
            this.myWideTableNameList.push(data)
          }
        }
      })
    },
    allSerch () {
      this.postData = JSON.parse(JSON.stringify(this.serchData))
      this.getAllList(1)
    },
    getAllList (page) {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.PageIndex = page
      let url = this.$commonJs.returnQuery('/api/Download/DownloadQuery', data)
      this.$axiox.get(url).then(msg => {
        this.myAllList = msg.datas || []
        this.page = page
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    },
    returnType (type, num) {
      if (num === 1) {
        switch (type) {
          case 'Success':
            return '已准备'
          case 'WaitHandle':
            return '待处理'
          case 'Running':
            return '处理中'
          case 'DataError':
            return '处理失败'
          case 'StopUse':
            return '已失效'
          case 'Cancel':
            return '已取消'
        }
      } else {
        switch (type) {
          case 'Success':
            return '#00B828'
          case 'WaitHandle':
            return '#313131'
          case 'Running':
            return '#FFB800'
          case 'DataError':
            return '#EB0000'
          case 'StopUse':
          case 'Cancel':
            return '#B7B7B7'
        }
      }
    },
    allVideo (item) {
      this.subscriptionData.parameterJsonList = item.parameterJson.split(',') || []
      this.subscriptionData.fileType = ''
      let fileIndex = item.fileName.lastIndexOf('.')
      this.subscriptionData.fileType = item.fileName.substring(fileIndex + 1, item.fileName.length)
      this.showModel = true
    },
    returnWeek (type) {
      switch (type) {
        case 'EveryDay':
          return '每天'
        case 'EveryWeek':
          return '每周'
        case 'EveryMonth':
          return '每月'
      }
      return ''
    },
    addDownloadLog (historyId, actionName, module) {
      let logInfo = {
        id: 0,
        historyId: historyId,
        actionName: actionName,
        module: module,
        remark: '',
        isSuccess: false
      }
      this.$axiox.post('/api/SystemLog/InsertDownloadSyncLog', logInfo).then(msg => {
        this.logId = msg.data || 0
      })
    },
    confirmExport (item) {
      this.isBtn = true
      setTimeout(p => {
        this.isBtn = false
      }, 2000)
      let that = this
      // that.$commonJs.addDownloadLog(item.id, '开始下载', '数据下载')
      that.addDownloadLog(item.id, '开始下载', '个人下载任务记录')
      let url = ''
      that.uploadMdoel = 0
      var xmlResquest = new XMLHttpRequest()
      url = this.$baseUrlConfig.baseUrl + '/api/Download/DownLoadFile?hisId=' + item.id
      xmlResquest.open('GET', url, true)
      xmlResquest.onprogress = function (e) {
        var percent = e.loaded / e.total
        that.uploadMdoel = parseInt(percent * 100)// progress 在data中定义的全局变量，显示的进度
        // console.log(that.uploadPercent)
        that.upName = item.fileName
        that.showModel4 = true
      }
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.localStorage.getItem('gskToken'))
      xmlResquest.setRequestHeader('Ocp-Apim-Subscription-Key', this.$baseUrlConfig.ocpKey)
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        if (content.type) {
          if (content.type.indexOf('json') >= 0) {
            that.$commonJs.updateDownloadLog(that.logId, item.id, '下载完成', '个人下载任务记录', false)
            that.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '暂无数据',
              stayTime: 5
            })
            that.showModel4 = false
            return
          }
        }
        var elink = document.createElement('a')
        elink.download = item.fileName
        elink.style.display = 'none'
        var blob = new Blob([content])
        if (that.$IENum === 11) {
          window.navigator.msSaveOrOpenBlob(blob, name + '.xls')
        } else {
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          document.body.removeChild(elink)
        }
        that.$commonJs.updateDownloadLog(that.logId, item.id, '下载完成', '个人下载任务记录', true)
        that.showModel4 = false
      }
      xmlResquest.send()
    },
    allCancel (item) {
      this.$commonJs.doubleComfirm({
        content: '是否取消处理？',
        successFun: msg => {
          this.$axiox.get('/api/Download/CancelDownload?id=' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '取消成功',
              stayTime: 5
            })
            this.getAllList(this.page)
          })
        },
        errorFun: msg => {
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/myDnload/myOneDnloadTaskList.vue